// Digital through TowBook / TowMagic
export const DIGITAL_IN_NETWORK_PREFERRED = 'Digital In-Network Preferred';
export const DIGITAL_NON_PREFERRED = 'Digital Non-Preferred';

// Treat these categories as "analog" we must call them for service
// the only difference is NON_DIGITAL_NON_PREFERRED doesn't need a GhostCard / approval
export const NON_DIGITAL_NON_PREFERRED = 'Non-Digital Non-Preferred';
export const OUT_OF_NETWORK = 'Out Of Network';
// 'Other' category is not supported anymore
// export const OTHER = 'Other';

// Categories of providers that can be digital or analog
export const CLIENT_PREFERRED = 'Client Preferred';
export const NETWORK_PREFERRED = 'Network Preferred';

// This can be digital or analog how do I ascertain this?
export const SPECIAL_OPPORTUNITY = 'Special Opportunity';

export const DIGITAL_ONLY_PROVIDER_CATEGORIES = [DIGITAL_IN_NETWORK_PREFERRED, DIGITAL_NON_PREFERRED];
export const ANALOG_ONLY_PROVIDER_CATEGORIES = [NON_DIGITAL_NON_PREFERRED, OUT_OF_NETWORK];

export const IN_NETWORK_PROVIDER_CATEGORIES = [
  CLIENT_PREFERRED,
  NETWORK_PREFERRED,
  DIGITAL_NON_PREFERRED,
  NON_DIGITAL_NON_PREFERRED,
  SPECIAL_OPPORTUNITY
];

export const IN_NETWORK_NON_DIGITAL_PROVIDERS = [NON_DIGITAL_NON_PREFERRED, SPECIAL_OPPORTUNITY];

export const OUT_OF_NETWORK_PROVIDER_CATEGORIES = [
  OUT_OF_NETWORK
];

export const PROVIDER_SEARCH_DEFAULT_PAGE_SIZE = 500;
